export default "__VITE_ASSET__ea0a3ac3__"